export const messages = {
  en: {
    allocationOrder: {
      queryCondition: 'Query Conditions',
      inputOrderId: 'Please enter allocation order number',
      selectSrcWarehouse: 'Please select source warehouse',
      selectTargetWarehouse: 'Please select target warehouse',
      selectStatus: 'Please select status',
      assetAllocation: 'Asset Allocation',
      allocation: 'Allocation',
      orderId: 'Order ID',
      productName: 'Product Name',
      specName: 'Specification',
      srcShop: 'Source Shop',
      srcWarehouse: 'Source Warehouse',
      targetShop: 'Target Shop',
      targetWarehouse: 'Target Warehouse',
      productCount: 'Quantity',
      allocationPerson: 'Allocation Person',
      status: 'Status',
      allocationTime: 'Allocation Time',
      operation: 'Operation',
      audit: 'Audit',
      inStock: 'In Stock',
      editAllocation: 'Edit Allocation',
      selectTargetWarehouseRequired: 'Please select target warehouse',
      productCountRequired: 'Quantity must be greater than 0',
      auditInfo: 'Audit Information',
      auditStatus: 'Audit Status',
      selectAuditStatus: 'Please select audit status',
      agree: 'Agree',
      reject: 'Reject',
      reason: 'Reason',
      inputReason: 'Please enter reason',
      selectAuditStatusRequired: 'Please select audit status',
      inputReasonRequired: 'Please enter reason',
      reasonMaxLength: 'Reason cannot exceed 200 characters',
      auditSuccess: 'Audit successful',
      confirmDelete: 'Confirm to delete this allocation order?'
    },
    deleteAllocationOrder: {
      confirmDelete: 'Confirm to delete this allocation order?'
    }
  },
  zh: {
    allocationOrder: {
      queryCondition: '查询条件',
      inputOrderId: '请输入调拨单号',
      selectSrcWarehouse: '请选择源仓库',
      selectTargetWarehouse: '请选择目标仓库',
      selectStatus: '请选择状态',
      assetAllocation: '资产调拨',
      allocation: '调拨',
      orderId: '调拨单号',
      productName: '商品名称',
      specName: '商品规格',
      srcShop: '源店铺',
      srcWarehouse: '源仓库',
      targetShop: '目标店铺',
      targetWarehouse: '目标仓库',
      productCount: '商品数量',
      allocationPerson: '调拨人',
      status: '状态',
      allocationTime: '调拨时间',
      operation: '操作',
      audit: '审核',
      inStock: '入库',
      editAllocation: '修改调拨申请',
      selectTargetWarehouseRequired: '请选择目标仓库',
      productCountRequired: '商品数量必须大于0',
      auditInfo: '审核信息',
      auditStatus: '审核状态',
      selectAuditStatus: '请选择审核状态',
      agree: '同意',
      reject: '拒绝',
      reason: '原因',
      inputReason: '请输入原因',
      selectAuditStatusRequired: '请选择审核状态',
      inputReasonRequired: '请输入原因',
      reasonMaxLength: '原因不能超过200个字符',
      auditSuccess: '审核成功',
      confirmDelete: '确定删除该调拨单吗？'
    },
    deleteAllocationOrder: {
      confirmDelete: '确定删除该调拨单吗？'
    }
  }
}